import { Check, X } from "lucide-react";

const money = (n) => `$${(Number(n) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function PricingBreakdown({ quote, discount = 0, credit = 0, showUnselected = true, dueLabel = "Total Due Today" }) {
  if (!quote || !quote.line_items) return null;
  const items = quote.line_items.filter((i) => showUnselected || i.selected);
  const finalTotal = Math.max(0, (Number(quote.total) || 0) - (Number(discount) || 0) - (Number(credit) || 0));
  return (
    <div data-testid="pricing-breakdown" className="bg-[#0C0C0C] border border-white/10 rounded-xl p-4 space-y-1.5">
      {items.map((i) => (
        <div key={i.key} className={`flex items-center gap-2 text-sm ${i.selected ? "text-white/85" : "text-white/30"}`} data-testid={`price-line-${i.key}`}>
          {i.selected
            ? <Check size={14} className="text-emerald-400 shrink-0" />
            : <X size={14} className="text-white/25 shrink-0" />}
          <span className="min-w-0 truncate">{i.label}
            {i.selected && i.unit === "day" && i.amount > 0 && <span className="text-white/35 text-xs ml-1.5">{money(i.rate)}/day × {i.qty}</span>}
            {!i.selected && <span className="text-white/25 text-xs ml-1.5">Not selected</span>}
            {i.overridden && <span className="text-[#F2B705] text-[10px] ml-1.5 uppercase font-bold">adjusted</span>}
          </span>
          <span className={`ml-auto shrink-0 font-semibold ${i.selected ? "" : "line-through text-white/20"}`}>
            {i.selected ? money(i.amount) : money(i.key === "byoi" ? 0 : i.rate * (i.unit === "day" ? i.qty : 1))}
          </span>
        </div>
      ))}
      {Number(quote.tax) > 0 && (
        <div className="flex items-center gap-2 text-sm text-white/85" data-testid="price-line-tax">
          <Check size={14} className="text-emerald-400 shrink-0" />
          <span>Taxes ({quote.tax_config?.rate_pct}%)</span>
          <span className="ml-auto font-semibold">{money(quote.tax)}</span>
        </div>
      )}
      {Number(discount) > 0 && (
        <div className="flex items-center gap-2 text-sm text-emerald-300" data-testid="price-line-discount">
          <Check size={14} className="text-emerald-400 shrink-0" />
          <span>Discounts / Credits</span>
          <span className="ml-auto font-semibold">-{money(discount)}</span>
        </div>
      )}
      <div className="flex items-center justify-between border-t border-white/15 pt-2 mt-2">
        <span className="text-white font-bold text-sm">{dueLabel}</span>
        <span className="font-display font-black text-xl text-gold-gradient" data-testid="pricing-grand-total">{money(finalTotal)}</span>
      </div>
    </div>
  );
}
